import { EDealType } from 'shared/map-search/types/chatModal';

import { IApplicationState } from '../../types/redux';

export function selectOfferChatDealType(state: IApplicationState): EDealType | undefined {
  return state.chatModal.dealType;
}
